module.exports = __webpack_public_path__ + "static/img/lv0.875f3e66.webp";